import {useSelector} from 'react-redux';
import {selectors} from 'store/slices/files';

export const useRecentFiles = () => {
  const items = useSelector(selectors.getItems);
  return {today: items, yesterday: {}, lastMonth: {}};
};
